import React, { PureComponent, Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    View,
    Image,
    StyleSheet,
    TouchableOpacity,
    FlatList
} from 'react-native';

import {
    JDTouchable,
    JDText,
    JDImage,
    JDScrollView
} from '@jdreact/jdreact-core-lib';

import { utils } from '@ltfe/ltfe-core-lib';
import { tip, getLabel, mtaPV, mta, closeShare } from '../common/utils';
import { get } from '../common/fetch';
import img from '../common/img';
import Stars from '../components/stars';
import Loading from '../components/common/loading';
import NoMore from '../components/common/no-more';
import Tag from '../components/common/tag';
import sgmReport from '../common/sgmUtil';

const { pt } = utils;

class HistoryList extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            tabs: [
                { text: '想看', class: 'tabs_wrap_left' },
                { text: '看过', class: 'tabs_wrap_middle' },
                { text: '去过', class: 'tabs_wrap_right' }
            ],
            curPage: this.props.page - 1,
            // movieInfo: history.movieInfo,
            // thinkInfo: history.thinkInfo,
            // cinemaInfo: history.cinemaInfo,
            movieInfo: [],
            thinkInfo: [],
            cinemaInfo: [],
            loading: true
        };
        this._onChangeTab = this._onChangeTab.bind(this);
        this.setTab = this.setTab.bind(this);
        this._toMovieList = this._toMovieList.bind(this);
        this._setScore = this._setScore.bind(this);
    }

    static defaultProps = {
        // page: 1
    }

    render() {
        const { movieInfo, tabs, curPage, thinkInfo, cinemaInfo, loading } = this.state;

        // const { page } = this.props;
        // movieInfo.push(history.movieInfo)

        return (
            <View style={ st.context }>

                {this.setTitle('我的电影票')}

                <View style={ st.tabs }>
                    {
                        tabs.map((val, inx) => (
                            <JDTouchable activeOpacity={ 0.5 } style={ [st.tabs_wrap, st[val.class]] } key={ inx } onPress={ () => this.setTab(inx) } >
                                <View style={ [st.tab_view, inx == curPage ? st.tab_view_red : {}] }>
                                    <JDText style={ [st.tab_txt, inx == curPage && st.tab_txt_red] }>{val.text}</JDText>
                                </View>
                            </JDTouchable>
                        ))
                    }
                </View>

                <JDScrollView style={ { backgroundColor: '#fff' } } >

                    {loading && <View style={ { paddingTop: pt(250) } }><Loading /></View>}
                    {/* 想看 */}
                    {!loading && curPage == 0 && <FlatList
                        data={ thinkInfo }
                        renderItem={ (info, index) => <WantMovieItem index={ index } movieInfo={ info.item } /> }
                        keyExtractor={ (item, index) => index + '' }
                        ListEmptyComponent={ () => <NoMore /> }
                    />}

                    {/* 看过 */}
                    {!loading && curPage == 1 && <FlatList
                        data={ movieInfo }
                        renderItem={ (info) => <HaveSeeList item={ info.item } setScore={ this._setScore } /> }
                        keyExtractor={ (item, index) => index + '' }
                        ListEmptyComponent={ () => <NoMore /> }
                    />}

                    {/* 去过 */}
                    {!loading && curPage == 2 && <FlatList
                        data={ cinemaInfo }
                        renderItem={ (info) => <Been toMovieList={ this._toMovieList } cinemaInfo={ info.item } /> }
                        keyExtractor={ (item, index) => index + '' }
                        ListEmptyComponent={ () => <NoMore /> }
                    />}

                </JDScrollView>

            </View>
        );
    }

    componentDidFocus() {
        mtaPV('MyList');
        this.getInfo(this.props.page);
    }

    componentDidMount() {
        closeShare();
        this.setState({
            curPage: this.props.page
        });
        this.getInfo(this.props.page);
    }

    setTab(curPage) {
        // '想看', '看过', '去过'
        const nowPage = this.state.curPage;

        if (curPage === nowPage) {
            return;
        }
        const type = ['MyWantTab', 'MySawTab', 'MyCinemaTab'];

        mta(type[curPage], 'MyList');

        this.setState({
            curPage
        });
        this.getInfo(curPage);
    }

    /* 去过的影院 */
    _toMovieList(cinemaId, scheduleType) {
        if (scheduleType) {
            this.context.router.toMovieList({ cinemaId });
        } else {
            const txt = scheduleType === 0 ? '暂无排期' : '已下线';

            tip(`该影院${txt}`);
        }
    }

    /* 看过的评分 */
    _setScore(movieId, movieName, rateScore) {
        if (rateScore) {
            get('userWannaSeeOrScore', {
                movieId,
                movieName,
                starLevel: rateScore,
                // operType: 2,
                flag: 10
            }, true).then(res => {
                // this.getInfo(1)

                tip('评分成功');
            }).catch(() => {
                tip('评分失败，请重试');
            });
            let str = ''
            if(!movieId || !movieName || !rateScore){
                sgmReport('1001', {function_id: 'userWannaSeeOrScore',message:'缺少参数movieId/movieName/rateScore'}, 3)
            }
        } else {
            tip('请先选择分数');
        }
    }

    getInfo(type) {
        const { cur_city } = this.props;

        const apiName = {
            thinkInfo: 'getUserWannaSeeMovieInfoList', // 想看
            movieInfo: 'getUserSeenTheMovieList', // 看过
            cinemaInfo: 'getGoneCinemaList' // 去过
        };

        this.setState({
            loading: true
        });

        const stateName = Object.keys(apiName)[type];

        const body = apiName[stateName] == 'getUserWannaSeeMovieInfoList' ? { cityId: cur_city.cityId } : {};

        get(apiName[stateName], body).then(res => {
            this.setState({
                [stateName]: res.data,
                loading: false
            });

            if((stateName === 'thinkInfo' || stateName === 'movieInfo') && res.data && res.data.length){
                const hasEmpty = res.data.some(item =>  !item.movieImgUrl);
                if(hasEmpty){
                    sgmReport('1002', {function_id: apiName[stateName], message:'返回数据缺少图片地址'}, 3)
                }
            }
        });

        if(!cur_city.cityId){
            sgmReport('1001', {function_id: apiName[stateName],message:'缺少参数cityId'}, 3)
        }
    }

    _onChangeTab(ops) {
    }

    setTitle = (title) => {
        document.title = title;
    }
}

class WantMovieItem extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { movieInfo, index } = this.props;

        const theIndex = index || '';

        return (
            <View style={ st.movie_item_wrap }>
                <TouchableOpacity
                    style={ { flexDirection: 'row' } }
                    activeOpacity={ 0.5 }
                    onPress={ () => {
                        this.context.router.toMovieDetail({ movieId: movieInfo.movieId });
                        // 电影票sku_movieID_A/B（A：待映，B：热映）_顺序（列表的排序从1开始）
                        mta('WantInfo', 'MyList', `${movieInfo.jSkuId || 'sku'}_${movieInfo.movieId}_${movieInfo.canPreOrder === 1 ? 'A' : movieInfo.canPreOrder === 2 ? 'B' : 'C'}_${theIndex}`);
                    } }
                >
                    <JDImage
                        style={ st.item_img }
                        source={ { uri: movieInfo.movieImgUrl } }
                    />
                    <View style={ st.item_info }>
                        <View style={ st.name_type_wrap }>
                            <JDText numberOfLines={ 1 } style={ st.movie_name }>{movieInfo.movieName}</JDText>
                            {!!movieInfo.showType && movieInfo.showType.split('-').length == 1 &&
                                <View style={ st.movie_type_one_wrap }>
                                    <JDText style={ st.movie_type_one }>{movieInfo.showType}</JDText>
                                </View>
                            }
                            {!!movieInfo.showType && movieInfo.showType.split('-').length == 2 &&
                                <View style={ { flexDirection: 'row', height: pt(15), alignItems: 'center' } }>
                                    <JDText style={ st.movie_type_left }>{movieInfo.showType.split('-')[0]}</JDText>
                                    <JDText style={ st.movie_type_right }>{movieInfo.showType.split('-')[1]}</JDText>
                                </View>
                            }
                        </View>

                        {
                            movieInfo.canPreOrder === 1
                                ? <JDText style={ st.movie_want }>
                                    {movieInfo.countWanna}
                                    <JDText style={ st.want_people }>人想看</JDText>
                                </JDText>
                                : movieInfo.grade
                                    ? <JDText style={ st.movie_fen }>观众评分 {movieInfo.grade}</JDText>
                                    : <JDText style={ st.movie_fen }>暂无评分</JDText>
                        }

                        <JDText numberOfLines={ 1 } style={ st.movie_actor }>主演: {movieInfo.actors || '未知'}</JDText>

                        <JDText numberOfLines={ 1 } style={ st.movie_plan }>
                            <JDText style={ { fontSize: pt(10), fontWeight: 'normal' } }>{movieInfo.releaseDate}在中国大陆上映</JDText>
                        </JDText>

                    </View>
                </TouchableOpacity>
                {movieInfo.buttonFlag === 1 && movieInfo.canPreOrder === 1 &&
                    <TouchableOpacity activeOpacity={ 0.5 } style={ st.go_buy } onPress={ () => {
                        mta('WantPreSale', 'MyList', `${movieInfo.jSkuId}_${movieInfo.movieId}_${theIndex}`);
                        this.context.router.toMovieSchedule({ movieId: movieInfo.movieId });
                    } }>
                        <JDImage style={ st.movie_item_goBuy } source={ img.preSale } />
                        <View style={ st.yu_shou_wrap }>
                            <JDText style={ st.yu_shou }>预售</JDText>
                        </View>
                    </TouchableOpacity>
                }
                {movieInfo.buttonFlag === 1 && movieInfo.canPreOrder !== 1 &&
                    <TouchableOpacity activeOpacity={ 0.5 } style={ st.go_buy } onPress={ () => {
                        mta('WantBuy', 'MyList', `${movieInfo.jSkuId}_${movieInfo.movieId}_${theIndex}`);
                        this.context.router.toMovieSchedule({ movieId: movieInfo.movieId });
                    } }>
                        <JDImage style={ st.movie_item_goBuy } source={ img.go_buy } />
                        <View style={ st.yu_shou_wrap }>
                            <JDText style={ st.yu_shou }>购票</JDText>
                        </View>
                    </TouchableOpacity>
                }
            </View>
        );
    }
}

class HaveSeeList extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            rateScore: 0,
            hasScore: false
        };
        this.rate = this.rate.bind(this);
        this.setScore = this.setScore.bind(this);
    }

    render() {
        const { item, setScore } = this.props;
        const { rateScore, hasScore } = this.state;

        const theIndex = '';

        return (
            <View style={ st.havesee } >
                <JDTouchable activeOpacity={ 0.5 } onPress={ () => {
                    this.context.router.toMovieDetail({ movieId: item.movieId });
                    mta('SawInfo', 'MyList', `${item.jSkuId || 'sku'}_${item.movieId}_${item.erpOrderId || ''}`);
                } } >
                    <View style={ st.movie }>
                        <JDImage style={ st.img } source={ { uri: item.movieImgUrl } } />
                        <View style={ st.m_info }>
                            <JDText style={ st.m_title } numberOfLines={ 1 }>{item.movieName}</JDText>
                            <JDText numberOfLines={ 1 } style={ st.m_txt }>导演：{item.director || '未知'}</JDText>
                            <JDText numberOfLines={ 1 } style={ st.m_txt }>主演：{item.actor || '未知'}</JDText>
                            <JDText style={ [st.m_txt, st.m_gray] }>{item.releaseTime}在中国大陆上映</JDText>
                        </View>
                    </View>
                </JDTouchable>

                {
                    item.score > 0
                        ? <View style={ st.score }>
                            <JDText style={ st.my_txt }>我评</JDText>
                            <JDText style={ st.my_score }>{Number(item.score).toFixed(1)}分</JDText>
                            <View style={ { flexDirection: 'row' } }>
                                <Stars score={ item.score } size={ 15 } />
                            </View>
                            {/* <JDText></JDText> */}
                        </View>
                        : hasScore
                            ? <View style={ st.score }>
                                <JDText style={ st.my_txt }>我评</JDText>
                                <JDText style={ st.my_score }>{Number(rateScore).toFixed(1)}分</JDText>
                                <View style={ { flexDirection: 'row' } }>
                                    <Stars score={ rateScore } size={ 15 } />
                                </View>
                                {/* <JDText></JDText> */}
                            </View>
                            : <View style={ st.set_score_view }>
                                <View style={ { flexDirection: 'row' } }>
                                    <Stars score={ rateScore } size={ 15 } onPress={ this.rate } />
                                    {rateScore > 0 && <JDText style={ st.scrore_txt }>{Number(rateScore).toFixed(1)}分</JDText>}
                                    {rateScore > 0 && <JDText style={ st.scrore_txt_gray }>{getLabel(rateScore)}</JDText>}
                                </View>
                                <JDTouchable onPress={ () => {
                                    this.setScore(item.movieId, item.movieName, rateScore);
                                    mta('SawStar', 'MyList', `${item.jSkuId || 'sku'}_${item.movieId}_${item.erpOrderId || ''}`);
                                } }>
                                    <View style={ st.set_score }>
                                        <JDText style={ st.set_score_txt }>评分</JDText>
                                    </View>
                                </JDTouchable>
                            </View>
                }
            </View>

        );
    }

    setScore(movieId, movieName, rateScore) {
        if (rateScore) {
            get('userWannaSeeOrScore', {
                movieId,
                movieName,
                starLevel: rateScore,
                // operType: 2,
                flag: 10
            }, true).then(res => {
                // this.getInfo(1)
                this.setState({
                    hasScore: true
                });
                tip('评分成功');
            }).catch(() => {
                tip('评分失败，请重试');
            });

            if(!movieId || !movieName || !rateScore){
                sgmReport('1001', {function_id: 'userWannaSeeOrScore',message:'缺少参数movieId/movieName/rateScore'}, 3)
            }
        } else {
            tip('请先选择分数');
        }
    }

    rate(index) {
        this.setState({
            rateScore: (index)
        });
    }
}

class Been extends PureComponent {
    render() {
        const { cinemaInfo, toMovieList } = this.props;

        return (
            <TouchableOpacity
                activeOpacity={ 0.5 }
                style={ st.cinema_item }
                onPress={ () => {
                    toMovieList(cinemaInfo.cinemaId, cinemaInfo.scheduleType);
                    // cinemaID_是否常去影院（0：否，1：是）
                    mta('BeenInfo', 'MyList', `${cinemaInfo.cinemaId}_0`);
                } }
            >
                <View style={ [st.cinema_name_wrap, st.cinema_common] }>
                    <JDText numberOfLines={ 1 } style={ st.cinema_name }>{cinemaInfo.cinemaName}</JDText>
                </View>
                <View style={ [st.cinema_address_wrap, st.cinema_common] }>
                    <JDText numberOfLines={ 1 } style={ st.cinema_address }>{cinemaInfo.address}</JDText>
                    <JDText style={ st.cinema_km }>{cinemaInfo.cinemaDistanceStr}</JDText>
                </View>

                <Tag cinemaTag={ cinemaInfo.cinemaTag } key={ 3 } />

                {cinemaInfo.promotionType >= 0 &&
                    <View style={ st.item }>
                        <View style={ st.v_tip }>
                            <View style={ st.tip }>
                                <View style={ st.v_scale }>
                                    <JDText style={ st.scale }>惠</JDText>
                                </View>
                            </View>
                            <JDText style={ st.i_text }>{ cinemaInfo.promoDesc }</JDText>
                        </View>
                    </View>
                }

                {!!cinemaInfo.isFreqCinema && <Image style={ st.cinema_been } source={ img.been } />}
            </TouchableOpacity>
        );
    }
}

HistoryList.contextTypes = {
    router: PropTypes.object
};

HaveSeeList.contextTypes = {
    router: PropTypes.object
};

WantMovieItem.contextTypes = {
    router: PropTypes.object
};
const st = StyleSheet.create({
    context: {
        flex: 1
    },
    tabs: {
        height: pt(40),
        backgroundColor: '#fff',
        borderColor: '#f1f1f1',
        borderBottomWidth: pt(1),
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingHorizontal: pt(25)
    },
    tabs_wrap: {
        flex: 1
    },

    tab_view: {
        height: pt(39),
        alignItems: 'center',
        justifyContent: 'center',
        borderBottomWidth: pt(2),
        borderColor: '#fff',
        paddingHorizontal: pt(5),
        flexGrow: 0
    },
    tab_view_red: {
        borderBottomWidth: pt(2),
        borderColor: '#E2231A'
    },
    tab_txt: {
        fontSize: pt(14),
        color: '#666'
    },
    tab_txt_red: {
        color: '#E2231A',
        fontWeight: 'bold'
    },

    // 看过
    havesee: {
        paddingHorizontal: pt(10),
        backgroundColor: '#fff',
        paddingBottom: pt(10)
    },
    movie: {
        marginTop: pt(11),
        marginBottom: pt(13),
        flexDirection: 'row'
    },
    img: {
        height: pt(88),
        width: pt(65),
        marginRight: pt(9)
    },
    m_info: {
        justifyContent: 'space-around'
    },
    m_txt: {
        fontSize: pt(12),
        color: '#252525',
        width: pt(250)
    },
    m_gray: {
        color: '#898989'
    },
    m_title: {
        color: '#000',
        fontSize: pt(14)

    },
    // 评分
    score: {
        backgroundColor: '#F5F7F8',
        height: pt(36),
        paddingHorizontal: pt(12),
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'row',
        borderRadius: pt(3)
    },
    set_score_view: {
        backgroundColor: '#F5F7F8',
        height: pt(36),
        paddingHorizontal: pt(12),
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        borderRadius: pt(3)
    },
    scrore_txt: {
        color: '#FFD405',
        fontSize: pt(12)
    },
    scrore_txt_gray: {
        color: '#898989',
        fontSize: pt(12),
        marginLeft: pt(5)
    },
    set_score: {
        height: pt(26),
        width: pt(52),
        borderRadius: pt(26),
        borderColor: '#F56A00',
        borderWidth: pt(1),
        justifyContent: 'center',
        alignItems: 'center'
    },
    set_score_txt: {
        fontSize: pt(12),
        color: '#F56A00'
    },
    // 去过
    cinema_item: {
        backgroundColor: '#fff',
        paddingVertical: pt(12),
        borderBottomWidth: 1,
        borderBottomColor: 'rgba(0,0,0,0.1)'
    },
    cinema_common: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: pt(18),
        paddingLeft: pt(15)
    },
    cinema_name_wrap: {
        height: pt(22),
        marginBottom: pt(4)
    },
    cinema_name: {
        fontSize: pt(16),
        width: pt(270)
    },

    cinema_address_wrap: {
        height: pt(18)
    },
    cinema_address: {
        color: '#898989',
        fontSize: pt(12),
        width: pt(270)
    },
    cinema_km: {
        color: '#898989',
        fontSize: pt(13)
    },

    cinema_been: {
        position: 'absolute',
        height: pt(24),
        width: pt(24),
        right: 0
    },
    // 促销
    item: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingLeft: pt(15),
        alignItems: 'center',
        marginTop: pt(7)
    },
    v_tip: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    tip: {
        height: pt(15),
        width: pt(14),
        borderRadius: pt(2),
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: pt(5),
        backgroundColor: '#F56A00'
    },
    scale: {
        fontSize: pt(10),
        color: '#fff'
    },
    i_text: {
        color: 'rgba(0,0,0,.45)',
        fontSize: pt(12)
    },
    // 相看
    movie_item_wrap: {
        paddingVertical: pt(14),
        borderTopWidth: 1,
        borderColor: 'rgba(0,0,0,0.1)',
        flexDirection: 'row',
        backgroundColor: '#fff',
        paddingHorizontal: pt(10),
        marginTop: pt(-1)
    },
    item_img: {
        height: pt(88),
        width: pt(60),
        borderRadius: pt(3)
    },
    item_info: {
        width: pt(225),
        marginLeft: pt(14),
        justifyContent: 'space-between',
        paddingVertical: pt(4)
    },
    name_type_wrap: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    movie_name: {
        fontSize: pt(14),
        marginRight: pt(8)
    },
    movie_type_one_wrap: {
        paddingHorizontal: pt(3),
        borderRadius: pt(3),
        backgroundColor: '#898989'
    },
    movie_type_one: {
        fontSize: pt(11),
        color: '#fff',
        backgroundColor: 'transparent'
    },
    movie_type_left: {
        height: pt(15),
        fontSize: pt(11),
        paddingHorizontal: pt(3),
        borderTopLeftRadius: pt(3),
        borderBottomLeftRadius: pt(3),
        color: '#fff',
        backgroundColor: '#898989'
    },
    movie_type_right: {
        height: pt(15),
        fontSize: pt(11),
        paddingHorizontal: pt(3),
        color: '#898989',
        backgroundColor: '#fff',
        borderTopRightRadius: pt(3),
        borderBottomRightRadius: pt(3),
        borderWidth: 1,
        borderColor: '#979797'
    },
    movie_want: {
        color: '#FFAE18',
        fontSize: pt(14),
        fontWeight: 'bold'
    },
    want_people: {
        color: '#898989',
        fontSize: pt(10),
        fontWeight: 'normal'
    },
    movie_actor: {
        color: '#252525',
        fontSize: pt(12)
    },
    movie_plan: {
        color: '#898989',
        fontSize: pt(11),
        fontWeight: 'bold'
    },
    go_buy: {
        position: 'relative',
        marginTop: pt(6),
        height: pt(30),
        // backgroundColor: 'pink',
        justifyContent: 'center',
        alignItems: 'center'
    },
    movie_item_goBuy: {
        width: pt(54),
        height: pt(26)
    },
    yu_shou_wrap: {
        position: 'absolute',
        // height: pt(30),
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        justifyContent: 'center',
        alignItems: 'center'
    },
    yu_shou: {
        color: '#fff',
        fontSize: pt(13),
        // fontWeight: 'bold',
        backgroundColor: 'transparent'
    },
    // 看过
    my_txt: {
        color: '#666666',
        marginRight: pt(4),
        fontSize: pt(12)
    },
    my_score: {
        fontSize: pt(18),
        color: '#252525',
        marginRight: pt(10)
    },
    movie_fen: {
        color: '#FFAE18',
        fontSize: pt(11),
        fontWeight: 'bold'
    }
});
const select = (state) => {
    const { cur_city } = state.index;

    return {
        cur_city
    };
};

export default connect(select, null, null, { withRef: true })(HistoryList)
;
